import React from "react";
import {
  Breadcrumb,
  Calendar,
  Callout,
  Checkbox,
  DayOfWeek,
  DefaultButton,
  DirectionalHint,
  Dropdown,
  DropdownMenuItemType,
  FocusTrapZone,
  IDropdownOption,
  ISelectableOption,
  PrimaryButton,
  Stack,
  Text,
  TextField,
  Toggle,
  TooltipHost,
} from "@fluentui/react";
import { useHistory, useParams } from "react-router-dom";
import {
  getADataCenter,
  getFloorsWhichHasMorSensors,
  searchQuadrantsOfDC,
} from "../../../services/datacenter/DatacenterService";
import {
  getMorPduReadings,
  getMorPduReadingsRackWise,
} from "../../../services/infrastructure-automation/InfrastructureAutmationService";
import { Loading } from "../../../services/Loading";
import { ToastContext } from "../../common/ToastProvider";
import moment from "moment";
import {
  IDataCenter,
  IMorPduReadings,
  IMorPduReadingsRackWise,
} from "../../../vm";
import { childrenGap, childrenGap8 } from "../../common/Constants";
import NoDataTile from "../../common/NoDataTile";
import { mdiCheck, mdiClose, mdiPencil } from "@mdi/js";
import Icon from "@mdi/react";
import {
  updateCustomerRackwisePdu,
  updateCustomerDedicatedPdu,
} from "../../../services/customers/CustomerService";
import { THEME } from "../../../utils/Styles";
import { DayPickerStrings } from "../../common/Constants";
import { toFixedValue } from "../../../services/UtilService";
import RackwiseReadings from "./RackwiseReadings";
import DedicatedReadings from "./DedicatedReadings";
import RackwiseBreakerLevelReadings from "./RackwiseBreakerLevelReadings";
import Datetime from "react-datetime";

var quadrantDict: any = {};

export interface PowerUtilizationWrapperMainProps {}

let calendarButtonElement: HTMLElement;

const PowerUtilizationWrapperMain: React.FC<PowerUtilizationWrapperMainProps> = () => {
  // hooks
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);
  const history = useHistory();
  // state
  const [isLoading, setLoading] = React.useState(false);
  const [state, setState] = React.useState({
    date: new Date(),
    showCallender: false,
    searchObj: {
      datacenterId: params.dataCenterId,
      floorId: "",
      startDate: moment(new Date()).startOf("month").toDate(),
      endDate: moment(new Date()).endOf("month").toDate(),
      isDedicated: false
    },
  } as {
    date: Date;
    showCallender: boolean;
    searchObj: {
      datacenterId: string;
      floorId: string;
      startDate: Date | string;
      endDate: Date | string;
      isDedicated: boolean
    };
  });
  const [floors, setFloors] = React.useState([] as IDropdownOption[]);
  const [datacenter, setDatacenter] = React.useState({} as IDataCenter);
  const [search, setSearch] = React.useState({
    datacenterId: params.dataCenterId,
    floorId: "",
    startDate: moment(new Date()).startOf("month").toDate(),
    endDate: moment(new Date()).endOf("month").toDate(),
  } as {
    datacenterId: string;
    floorId: string;
    startDate: Date | string;
    endDate: Date | string;
  });
  const [isDedicated, setDedicated] = React.useState(false);
  const [isRackWiseView, setIsRackWiseView] = React.useState(false);
  const [searchFromLogs, setSearchFromLogs] = React.useState(false);

  // local hook
  React.useLayoutEffect(() => {
    const asyncFunc = async () => {
      const result = await searchMetaDataForSearch(params.dataCenterId);
    };
    asyncFunc();
  }, []);

  const searchMetaDataForSearch = async (datacenterId: string) => {
    // setState(true);
    setLoading(true);

    let result = await getADataCenter(datacenterId);
    if (result?.success) {
      setDatacenter(result.data);
      const fResult = await getFloorsWhichHasMorSensors({
        datacenterId: params.dataCenterId,
        type: "pdu",
      });

      // get Quadrant details
      const qResult = await searchQuadrantsOfDC(params.dataCenterId);
      if (qResult && qResult.success) {
        quadrantDict = qResult.data.reduce((acc: any, d) => {
          acc[d._id as string] = d.quadrant;
          return acc;
        }, {});
      }

      // get floor details
      if (fResult && fResult.success) {
        setState({
          ...state,
          searchObj: {
            ...state.searchObj,
            floorId: fResult.data[0]?.floorId as string,
          },
        });
        const floorOptions: IDropdownOption[] = [];
        let tempB: any;
        fResult.data.forEach((d) => {
          if (tempB == null || tempB !== d.buildingId) {
            if (tempB != null) {
              floorOptions.push({
                key: "divider_1",
                text: "-",
                itemType: DropdownMenuItemType.Divider,
              });
            }
            floorOptions.push({
              key: d.buildingId,
              text: d.buildingName,
              itemType: DropdownMenuItemType.Header,
            });
            tempB = d.buildingId;
          }
          floorOptions.push({
            key: d.floorId,
            text: d.floorName,
            data: { buildingName: d.buildingName },
          });
        });
        setFloors(floorOptions);
        if (floorOptions.length > 1) {
          setSearch({ ...search, floorId: floorOptions[1].key as string });
          //   await searchMorReadings(floorOptions[1].key as string);
        }
      }
      setLoading(false);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setLoading(false);
    }
  };

  const onRenderOption = (option?: ISelectableOption): JSX.Element => {
    if (!option) return <div />;
    return (
      <div className="d-flex">
        {/* {!option.itemType && <Icon path={mdiFloorPlan} size={0.8} />} */}
        <span style={{ marginLeft: option.itemType ? "0px" : "12px" }}>
          {option.text}
        </span>
      </div>
    );
  };

  const onRenderTitle = (options?: IDropdownOption[]): JSX.Element => {
    if (!options) return <div />;
    const option = options[0];

    return (
      <div>
        <span>{option.data.buildingName + "-" + option.text}</span>
      </div>
    );
  };

  const onSearch = () => {
    setState({
      ...state,
      searchObj: {
        ...state.searchObj,
        floorId: search.floorId,
        startDate: search.startDate,
        endDate: search.endDate,
      },
    });
  };

  const handleChangeToggle = async (checked: boolean) => {
    setIsRackWiseView(checked);
  };

  const closeCallender = () => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  return (
    <React.Fragment>
      {isLoading && <Loading />}
      <Stack>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: datacenter.name ? datacenter.name : "Datacenter",
                key: "datacenter",
              },
              {
                text: "Infrastructures (Automation)",
                key: "infrastructure-automation",
                onClick: () => {
                  history.goBack();
                },
              },
              {
                text: "Power Utilization",
                key: "power-utilization",
                isCurrentItem: true,
              },
            ]}
          />
        </Stack.Item>
      </Stack>
      <br />
      <Stack horizontalAlign="start" tokens={childrenGap8}>
        <Stack.Item>
          <Stack horizontal wrap tokens={childrenGap} verticalAlign="center">
            <Stack.Item>
              <Dropdown
                placeholder="Select a Floor"
                selectedKey={search.floorId}
                styles={{ dropdown: { width: 200 } }}
                options={floors}
                onRenderOption={onRenderOption}
                onRenderTitle={onRenderTitle}
                onChange={(e, v: IDropdownOption | undefined) => {
                  if (v) {
                    setSearch({ ...search, floorId: v.key as string });
                  }
                }}
              />
            </Stack.Item>
            {!searchFromLogs ?  (
            <Stack.Item>
              {/* <DatePicker
                firstDayOfWeek={DayOfWeek.Sunday}
                showMonthPickerAsOverlay={true}
                value={new Date(search.startDate)}
                showGoToToday={false}
                onSelectDate={(date: Date | null | undefined) => {
                  setSearch({
                    ...search,
                    startDate: date as Date,
                    endDate: date as Date,
                  });
                }}
                placeholder="Select a date..."
                ariaLabel="Select a date"
              /> */}
              <div
                ref={(calendarBtn) => (calendarButtonElement = calendarBtn!)}
              >
                <DefaultButton
                  text={
                    !state.date
                      ? "Select a month"
                      : moment(state.date).format("MMM-YYYY")
                  }
                  onClick={() => setState({ ...state, showCallender: true })}
                  className="month-picker-btn"
                />
              </div>
              {state.showCallender && (
                <Callout
                  isBeakVisible={false}
                  // className="ms-DatePicker-callout"
                  gapSpace={0}
                  doNotLayer={false}
                  target={calendarButtonElement}
                  directionalHint={DirectionalHint.bottomLeftEdge}
                  onDismiss={() => closeCallender()}
                  setInitialFocus
                >
                  <FocusTrapZone
                    firstFocusableSelector="ms-DatePicker-day--today"
                    isClickableOutsideFocusTrap
                  >
                    <Calendar
                      // eslint-disable-next-line react/jsx-no-bind
                      onSelectDate={(date: Date | null | undefined) => {
                        setState({
                          ...state,
                          date: date as any,
                          showCallender: false,
                        });
                        setSearch({
                          ...search,
                          startDate: moment(date).startOf("month").toDate(),
                          endDate: moment(date).endOf("month").toDate(),
                        });
                      }}
                      onDismiss={() => closeCallender()}
                      isMonthPickerVisible={true}
                      value={state.date}
                      firstDayOfWeek={DayOfWeek.Sunday}
                      strings={DayPickerStrings}
                      isDayPickerVisible={false}
                      highlightCurrentMonth={false}
                      highlightSelectedMonth={true}
                      showMonthPickerAsOverlay={false}
                      showGoToToday={false}
                    />
                  </FocusTrapZone>
                </Callout>
              )}
            </Stack.Item>
            ) : (
              <Stack.Item className="custom-datepicker">
                 <Datetime
                  className="custom-field-group ms-TextField-fieldGroup height-32"
                  inputProps={{
                    className: "ms-TextField-field px-8 border-0 w-100",
                  }}
                  dateFormat="ddd MMM DD YYYY"
                  timeFormat="HH:mm"
                  value={state.date}
                  onChange={(date) => {
                     setState({
                        ...state,
                        date: moment(date).toDate(),
                     })
                      setSearch({
                          ...search,
                          startDate: moment(date).startOf("month").toDate(),
                          endDate: moment(date).toDate(),
                      });
                  }}
                 />
              </Stack.Item>
            )}
            <Stack.Item>
              <PrimaryButton text="Search" onClick={() => onSearch()} />
            </Stack.Item>
            {!isDedicated && !isRackWiseView && (
              <Stack.Item>
                  <Checkbox
                      label="Show Date/Time Picker"
                      checked={searchFromLogs}
                      onChange={(e, v) => {
                        setSearchFromLogs(v as boolean);
                      }}
                  />
              </Stack.Item>
            )}
          </Stack>
        </Stack.Item>
        {searchFromLogs && (
            <Stack.Item>
              <Text className="error-msg color-danger">*Depending upon the load on database that will be accessed, it may take about 15 minutes to give result of your query</Text>
            </Stack.Item>
        )}
      </Stack>
      <br />
      <Stack
        horizontal
        horizontalAlign="end"
        //  tokens={childrenGap}
      >
        <Stack.Item align="end">
          {!isDedicated && !isRackWiseView ? (
            <PrimaryButton
              text="Rackwise Readings (Breaker Level)"
              className="custom-primary-btn mr-16"
            />
          ) : (
            <DefaultButton
              text="Rackwise Readings (Breaker Level)"
              onClick={() => {
                handleChangeToggle(false);
                setDedicated(false);
                setState({...state, searchObj: {...state.searchObj, isDedicated: false}})
                setSearchFromLogs(false);
              }}
              className="custom-secondary-btn mr-16"
            />
          )}
        </Stack.Item>

        <Stack.Item align="end">
          {isRackWiseView ? (
            <PrimaryButton
              text="Rackwise Readings"
              className="custom-primary-btn mr-16"
            />
          ) : (
            <DefaultButton
              text="Rackwise Readings"
              onClick={async () => {
                await handleChangeToggle(true);
                setDedicated(false);
                setSearchFromLogs(false);
              }}
              className="custom-secondary-btn mr-16"
            />
          )}
        </Stack.Item>
        <Stack.Item align="end">
          {isDedicated ? (
            <PrimaryButton
              text="Dedicated Readings"
              className="custom-primary-btn"
            />
          ) : (
            <DefaultButton
              text="Dedicated Readings"
              onClick={() => {
                handleChangeToggle(false);
                setDedicated(true);
                setState({...state, searchObj: {...state.searchObj, isDedicated: true}})
                setSearchFromLogs(false);
              }}
              className="custom-secondary-btn"
            />
          )}
        </Stack.Item>
        {/* <Stack.Item align='end'>
          <Toggle
            className='custom-toggle'
            label='Show Dedicated'
            checked={isDedicated}
            // onText='On'
            // offText='Off'
            onChange={(ev: any, checked?: boolean) => {
              setDedicated(checked === true);
              setState({
                ...state,
                isOnEdit: false,
                pduIndex: undefined,
                phaseIndex: undefined,
              });
            }}
          />
        </Stack.Item>
        <Stack.Item align='end'>
          <Toggle
            className='custom-toggle'
            label='Show RackWise Readings'
            checked={isRackWiseView}
            onChange={(ev: any, checked?: boolean) => {
              handleChangeToggle(checked === true);
              // setState({
              //   ...state,
              //   isOnEdit: false,
              //   pduIndex: undefined,
              //   phaseIndex: undefined,
              // });
            }}
          />
        </Stack.Item> */}
      </Stack>
      <br />
      <Stack>
        <Stack.Item>
          {floors.length > 0 ? (
            isRackWiseView ? (
              <RackwiseReadings searchObj={state.searchObj} />
            ) : isDedicated ? (
              <DedicatedReadings searchObj={state.searchObj} />
            ) : (
              <RackwiseBreakerLevelReadings
                searchObj={state.searchObj}
                datacenterId={params.dataCenterId}
                searchFromLogs={searchFromLogs}
              />
            )
          ) : (
            <NoDataTile title="No Databases Found"></NoDataTile>
          )}
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default PowerUtilizationWrapperMain;
